exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fuller[data-v-aaaa50ca]{height:calc(100% - 5rem)}", ""]);

// exports
